export default "__VITE_ASSET__OjD8xPQE__"